import './Qute.css'

function Qute(){
  return(
    <div className='qute'>
      <div>
      <q >First, solve the problem. Then write the code</q>
      <br/>
      <span className='sub-text'>John Johnson</span>
      </div>
    </div>
  )
}
export default Qute;